import React from "react";
import { ErrorIcon } from "../../../icons/Error";
import { useTheme } from "@emotion/react";
import { Info } from "../../../icons";
import { Tick, Loading } from "@bale/icons";
import styles from "./InfoMessages.module.scss";
import classNames from "classnames";
export const HelpMessage = (props) => {
    const theme = useTheme();
    return (React.createElement("div", { className: classNames(styles.HelpWrapper) },
        React.createElement(Info, { className: styles.icon, color: theme.colors.dark[300], size: 20 }),
        React.createElement("p", null, props.message)));
};
export const ErrorMessage = (props) => {
    const theme = useTheme();
    return (React.createElement("div", { className: classNames(styles.ErrorWrapper), "data-testid": "textfield-error-message" },
        React.createElement(ErrorIcon, { size: 20, color: theme.colors.error }),
        React.createElement("p", null, props.message)));
};
export const SuccessMessage = (props) => {
    const theme = useTheme();
    return (React.createElement("div", { className: classNames(styles.SuccessWrapper) },
        React.createElement(Tick, { size: 20, color: theme.colors.success }),
        React.createElement("p", null, props.message)));
};
export const LoadingMessage = (props) => {
    const theme = useTheme();
    return (React.createElement("div", { className: classNames(styles.LoadingWrapper) },
        React.createElement(Loading, { size: 20, color: theme.colors.success, className: styles.LoadingIcon }),
        React.createElement("p", null, props.message)));
};
//# sourceMappingURL=InfoMessages.js.map